import axios from 'axios'
import {
  CategoryDjangoDto,
  CategoryDto,
  PieceCategoryInterface,
} from '../interfaces'
import { ListResponse } from '../interfaces/Shipment/ListResponseDto'
import { CategoryMapper, categoryDjangoToPieceCategory } from '../utils/mappers'
import { apiDjango } from './ApiDjango'

const CATEGORIES = [
  { id: '1', name: 'ACCESORIOS DEL HOGAR', code: '' },
  { id: '2', name: 'ACCESORIOS PARA ELECTRONICOS', code: '' },
  { id: '3', name: 'ALIMENTOS', code: '' },
  { id: '4', name: 'ALIMENTOS PARA MASCOTAS', code: '' },
  { id: '5', name: 'ARTICULOS DE ASEO', code: '' },
  { id: '6', name: 'ARTICULOS DE BEBE', code: '' },
  { id: '7', name: 'ARTICULOS DE BELLEZA', code: '' },
  { id: '8', name: 'ARTICULOS DE FIESTA', code: '' },
  { id: '9', name: 'ARTICULOS DE OFICINA', code: '' },
  { id: '10', name: 'ARTICULOS DEPORTIVOS', code: '' },
  { id: '11', name: 'ARTICULOS ESCOLARES', code: '' },
  { id: '12', name: 'ARTICULOS MEDICOS', code: '' },
  { id: '13', name: 'ARTICULOS PARA MASCOTAS', code: '' },
  { id: '14', name: 'CALZADO', code: '' },
  { id: '15', name: 'CORRESPONDENCIA', code: '' },
  { id: '16', name: 'ELECTRODOMESTICOS', code: '' },
  { id: '17', name: 'ELECTRONICOS', code: '' },
  { id: '18', name: 'EQUIPOS PROFESIONALES', code: '' },
  { id: '19', name: 'HERRAMIENTAS', code: '' },
  { id: '20', name: 'HIGIENE Y ASEO PERSONAL', code: '' },
  { id: '21', name: 'JUGUETES', code: '' },
  { id: '22', name: 'MAQUILLAJE', code: '' },
  { id: '23', name: 'MEDICINAS Y SUPLEMENTOS', code: '' },
  { id: '24', name: 'MISCELANEOS', code: '' },
  { id: '25', name: 'PARTES ELECTRONICAS', code: '' },
  { id: '26', name: 'REPUESTOS ELECTRONICOS', code: '' },
  { id: '27', name: 'REPUESTOS VEHICULOS', code: '' },
  { id: '28', name: 'ROPA', code: '' },
  { id: '29', name: 'PREPARED BY CUSTOMER', code: '' },
]

const { REACT_APP_URL_PATH_API, REACT_APP_URL_PATH_API_DJANGO } = process.env

// Carga masiva (API Django). GET /api/category?type= (1=Nacional, 2=Internacional).
// Lanza en caso de fallo para que el thunk del sub-slice lo capture (Promise.allSettled
// combina nacional+internacional; un tipo caido no bloquea, solo avisa).
export const getPieceCategoriesDjango = async (
  type: number = 1
): Promise<PieceCategoryInterface[]> => {
  try {
    const resp = await apiDjango.get(
      `${REACT_APP_URL_PATH_API_DJANGO}/category`,
      { params: { type } }
    )
    if (resp.status === 200 && resp.data && resp.data.error === false) {
      const list = (resp.data.data ?? []) as CategoryDjangoDto[]
      return list.map(categoryDjangoToPieceCategory)
    }
    console.error('getPieceCategoriesDjango: respuesta con error', {
      type,
      code: resp.data?.code,
      message: resp.data?.message,
    })
    throw new Error(resp.data?.message || 'No se pudieron obtener las categorias')
  } catch (error) {
    console.error('getPieceCategoriesDjango: fallo', { type, error })
    throw error
  }
}

export const getPieceCategories = async (): Promise<
  PieceCategoryInterface[] | undefined
> => {
  try {
    const response = await axios.get(
      `${REACT_APP_URL_PATH_API}/v1/Products/GetCategory`
    )
    if (response.status == 200) {
      var categoryresponse = response.data as ListResponse<CategoryDto[]>
      if (categoryresponse.didError == false) {
        var datamap = categoryresponse.model?.map((dto: CategoryDto) =>
          CategoryMapper(dto)
        )
        return datamap
      }
      return CATEGORIES
    }
  } catch (error) {}
  return []
}
